import { routerReducer } from '@ngrx/router-store';
import { ActionReducerMap, Store, createAction, props } from '@ngrx/store';
import { CompanyEffects } from '@platform/company/store/company.effects';
import { companyReducer } from '@platform/company/store/company.reducer';
import { DashboardEffects } from '@platform/dashboard/store/dashboard.effects';
import { dashboardReducer } from '@platform/dashboard/store/dashboard.reducer';
import { isEqual } from '@shared-lib/utils/is-equal';
import { AnalyticsEffects } from '@shared/store/analytics/analytics.effects';
import { LendersEffects } from '@shared/store/lenders/lenders.effect';
import { lendersReducer } from '@shared/store/lenders/lenders.reducer';
import { PlatformEffect } from '@shared/store/platform/platform.effects';
import { platformReducer } from '@shared/store/platform/platform.reducer';
import { tableReducer } from '@shared/store/table/table.reducer';
import { Observable, distinctUntilChanged } from 'rxjs';
import { AppStateModel } from '../models/app-state.model';
import { AuthEffect } from './auth/auth.effect';
import { authReducer } from './auth/auth.reducer';
import { RouteEffect } from './route/route.effect';
import { UserEffect } from './user/user.effect';
import { userReducer } from './user/user.reducer';

export const EFFECTS = [
  AnalyticsEffects,
  AuthEffect,
  CompanyEffects,
  DashboardEffects,
  PlatformEffect,
  RouteEffect,
  UserEffect,
  LendersEffects,
];

export const REDUCERS: ActionReducerMap<AppStateModel> = {
  auth: authReducer,
  company: companyReducer,
  currentUser: userReducer,
  dashboard: dashboardReducer,
  platform: platformReducer,
  route: routerReducer,
  tables: tableReducer,
  lenders: lendersReducer,
};

export type CustomComponentState = object & {
  lastCalledAction?: string;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const updateComponentState = (type: string) => createAction(type, props<{ componentState: CustomComponentState }>());

export const linkToGlobalState = (componentState$: Observable<CustomComponentState>, componentName: string, globalStore: Store): void => {
  componentState$.pipe(distinctUntilChanged((prev, next) => isEqual(prev, next))).subscribe((componentState) => {
    globalStore.dispatch(
      updateComponentState(`[${componentName}Store] ${componentState.lastCalledAction ?? 'Update Action'}`)({
        componentState,
      }),
    );
  });
};
